import React from 'react'

import { ReactComponent as TrashIcon } from '@app/assets/Small/Outline/Trash.svg'
import { IconButton } from '@app/lib/inputs/IconButton/IconButton'
import { useMobile } from '@app/services/useMobile'
import './index.scss'
export function DeleteButton({
  deleteMessage,
  messageId
}: {
  deleteMessage: (messageId: number) => void
  messageId: number
}) {
  // todo: move over finalized ModernChat & Button code from customer portal. then this is no longer needed:
  const { isMobile } = useMobile()
  const height = isMobile ? '1.5rem' : '1.25rem'
  const width = isMobile ? '1.5rem' : '1.25rem'

  return (
    <IconButton
      className={'modern-chat-delete-button'}
      variant={'ghost'}
      size={isMobile ? 'md' : 'sm'}
      color={'neutral'}
      aria-label={'Delete message'}
      onClick={() => deleteMessage(messageId)}
    >
      <TrashIcon height={height} width={width} />
    </IconButton>
  )
}
